import React, { useMemo } from "react";
import PropTypes from "prop-types";
import CompactMetricCard from "src/components/InsightsPage/Cards/CompactMetricCard";
import { getRAGStatus } from "src/util/teamMetrics";

const MemberCountMetric = ({
  metric,
  orgMetric,
  currentTeam,
  loading,
  targetChanged,
}) => {
  // Use team.memberCount to match the org chart card (includes vacancies/AI agents)
  const currentCount = currentTeam?.memberCount || metric.current || 0;
  const target = metric.target || 0;
  const delta = currentCount - target;

  const currentFormatted = useMemo(() => {
    return currentCount > 0 ? currentCount.toLocaleString() : "0";
  }, [currentCount]);

  const deltaFormatted = useMemo(() => {
    return delta === 0 ? "0" : delta > 0 ? `+${delta}` : `${delta}`;
  }, [delta]);

  const ragStatus = useMemo(() => {
    return getRAGStatus(currentCount, target, "headcount");
  }, [currentCount, target]);

  const subtitleText = useMemo(() => {
    // Format: "x / y / +/- z" (compact format)
    // Then add "Org: a" on second line
    const targetFormatted = metric.targetFormatted || "N/A";
    const orgTotal = orgMetric?.memberCount;
    const orgTotalText =
      orgTotal !== null && orgTotal !== undefined
        ? `Org: ${orgTotal.toLocaleString()}`
        : null;

    const subtitle = `${currentFormatted} / ${targetFormatted} / ${deltaFormatted}`;
    return orgTotalText ? `${subtitle}\n${orgTotalText}` : subtitle;
  }, [currentFormatted, metric.targetFormatted, deltaFormatted, orgMetric]);

  return (
    <CompactMetricCard
      icon={["far", "users"]}
      title="Member Count"
      current={currentCount}
      currentFormatted={currentFormatted}
      target={target}
      targetFormatted={metric.targetFormatted}
      deltaFormatted={deltaFormatted}
      ragStatus={ragStatus}
      subtitleText={subtitleText}
      loading={loading}
      targetChanged={targetChanged}
    />
  );
};

MemberCountMetric.propTypes = {
  metric: PropTypes.shape({
    current: PropTypes.number,
    target: PropTypes.number,
    targetFormatted: PropTypes.string,
  }).isRequired,
  orgMetric: PropTypes.shape({
    memberCount: PropTypes.number,
  }),
  currentTeam: PropTypes.shape({
    memberCount: PropTypes.number,
  }),
  loading: PropTypes.bool,
  targetChanged: PropTypes.bool,
};

export default MemberCountMetric;
